import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Adds theme transition classes to elements for smooth theme changes
 * @param baseClasses - Base Tailwind classes
 * @returns Merged classes with theme transition support
 */
export function withThemeTransition(baseClasses: ClassValue) {
  return cn(
    baseClasses,
    "transition-colors duration-400 ease-out"
  );
}

/**
 * Format a number with K, M, B suffixes
 */
export function formatLargeNumber(num: number): string {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num.toString();
}

/**
 * Format a date string into a human-readable format
 * @param dateString - Date string in ISO or other parseable format
 * @returns Formatted date string (e.g., "May 21, 2023")
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return dateString; // Return the original string if date is invalid
  }
  
  // Format the date
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long', 
    day: 'numeric'
  }).format(date);
} 